// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60d77dba","667":"0eef62ff","977":"7b5740ff"}[chunkId] + ".chunk.js";
};